import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { intialMessage, userMessage } from 'constants/ui.constants';
import { Contact, ContactStatus } from 'constants/contact.constants';

interface contactState {
	loading: boolean;
	formSuccess: boolean;
	message: userMessage;
	existingContacts: Contact[];
}

const initialState: contactState = {
	loading: false,
	formSuccess: false,
	message: intialMessage,
	existingContacts: [],
};

export const contactSlice = createSlice({
	name: 'contact',
	initialState,
	reducers: {
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setFormSuccess: (state, action: PayloadAction<boolean>) => {
			state.formSuccess = action.payload;
		},
		setMessage: (state, action: PayloadAction<userMessage>) => {
			state.message = action.payload;
		},
		setExistingContacts: (state, action: PayloadAction<Array<Contact>>) => {
			const contactsWithStatus = action.payload.map((item: Contact) => {
				return { ...item, status: ContactStatus.Approved };
			});
			state.existingContacts = contactsWithStatus;
		},
		updateExistingContacts: (state, action: PayloadAction<Contact>) => {
			const updatedContact = action.payload;
			const updatedContacts = state.existingContacts.map((contact: Contact) => {
				if (contact.email === updatedContact.email) {
					return updatedContact;
				}
				return contact;
			});
			state.existingContacts = updatedContacts;
		},
	},
});

export const {
	setLoading,
	setFormSuccess,
	setMessage,
	setExistingContacts,
	updateExistingContacts,
} = contactSlice.actions;

export const isLoading = (state: any) => state.contact?.loading;
export const getFormSuccess = (state: any) => state.contact.formSuccess;
export const getExistingContacts = (state: any) => state.contact.existingContacts;
export const getMessage = (state: any) => state.contact?.message;

export default contactSlice.reducer;
